import { render, staticRenderFns } from "./RegistProfile.vue?vue&type=template&id=540db692&scoped=true&"
import script from "./RegistProfile.vue?vue&type=script&lang=js&"
export * from "./RegistProfile.vue?vue&type=script&lang=js&"
import style0 from "./RegistProfile.vue?vue&type=style&index=0&id=540db692&prod&lang=scss&scoped=true&"
import style1 from "./RegistProfile.vue?vue&type=style&index=1&id=540db692&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540db692",
  null
  
)

export default component.exports